/** Tiny trend line. The exact number sits beside it, so the line is decorative. */
export default function Sparkline({ values }) {
  const nums = (values || []).map(Number).filter((n) => !Number.isNaN(n));
  if (nums.length < 2) return null;
  const min = Math.min(...nums);
  const max = Math.max(...nums);
  const span = max - min || 1;
  const width = 72;
  const height = 24;
  const points = nums
    .map((n, i) => {
      const x = (i / (nums.length - 1)) * width;
      const y = height - ((n - min) / span) * (height - 4) - 2;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden
      className="shrink-0 text-brand"
    >
      <polyline fill="none" stroke="currentColor" strokeWidth="1.5" points={points} />
    </svg>
  );
}
